export default "__VITE_PUBLIC_ASSET__a36ba107__"